import React from "react";
import { FTFlex } from "../flex";
import EffectRightResult from "./components/Content/Content";
import LeftContent from "./components/Left/Content";
import styles from "./index.module.scss"

/**
 * PC 端主操作区
 */
export default function MainActionFigure() {
  return (
    <FTFlex align="flex-start" justify="flex-start" className={styles.wrapper} gap={16}>
      <div  className={styles.left}>
        <LeftContent />
      </div>

      <div  className={styles.content}>
        <EffectRightResult />
      </div>
    </FTFlex>
  );
}
